<template>
  <div class="guidePageWrap">
    <div class="close_icon">
      <van-icon
        name="close"
        size=".5rem"
        @click="closeCommunity"
        v-show="
          this.$store.state.system == 'android' &&
          applets != 'xcx' &&
          !$store.state.isXcx &&
          this.$store.state.isInGame &&
          $store.state.gameType == 2
        "
      />
    </div>
    <div
      class="guidePage"
      :style="
        $padFalg == 'other' &&
        ($store.state.gameType == 2 || $store.state.gameType == 5) &&
        !tabView
          ? 'padding-top: 0rem;'
          : ''
      "
    >
      <div
        class="uploadPage_toptitle"
        v-if="
          $padFalg == 'other' &&
          $store.state.gameType != 2 &&
          $store.state.gameType != 4 &&
          $store.state.gameType != 5
        "
      >
        <div class="messageTop">
          <div class="messageTop_con">百科</div>
           <van-icon
            class="messageTop_right"
            name="close"
            v-show="
              this.$store.state.system == 'android' &&
              applets != 'xcx' &&
              !$store.state.isXcx &&
              this.$store.state.isInGame
            "
            @click="closeCommunity"
          />
        </div>
      </div>
      <div
        class="uploadPage_toptitle"
        style="background: #f5f5f5"
        v-if="$store.state.gameType == 2 && tabView"
      >
        <!-- <div
          v-if="$padFalg == 'other'"
          class="homePage_search"
          @click="toSearch"
        ></div> -->
        <div
          :class="`tab_intro ${currentTab == 1 ? ' tab_on' : ''}`"
          @click="changeTab(1)"
        >
          攻略
        </div>
        <div
          :class="`tab_info ${currentTab == 2 ? ' tab_on' : ''}`"
          @click="changeTab(2)"
        >
          百科
        </div>
        <div class="side_right_icon" v-if="$padFalg != 'other'"></div>
        <div class="search_btn_box" v-if="$store.state.gameType != 2">
          <div class="search_btn" @click="toSearch">
            <span></span>
            <p>搜索</p>
          </div>
        </div>
      </div>
      <div
        class="uploadPage_toptitle"
        style="background: #f5f5f5"
        v-if="$store.state.gameType == 3 && tabView"
      >
        <div
          v-if="$padFalg == 'other'"
          class="homePage_search"
          @click="toSearch"
        ></div>
        <div
          :class="`tab_intro ${currentTab == 1 ? ' tab_on' : ''}`"
          @click="dqssChangeTab(1)"
        >
          攻略
        </div>
        <div
          :class="`tab_info ${currentTab == 2 ? ' tab_on' : ''}`"
          @click="dqssChangeTab(2)"
        >
          百科
        </div>
        <div class="search_btn_box" v-if="$store.state.gameType != 3">
          <div class="search_btn" @click="toSearch">
            <span></span>
            <p>搜索</p>
          </div>
        </div>
      </div>
      <div
        class="uploadPage_toptitle"
        v-if="$store.state.gameType == 4 && tabView"
      >
        <div
          v-if="$padFalg == 'other'"
          class="homePage_search"
          @click="toSearch"
        ></div>
        <van-icon
          name="close"
          v-show="
            this.$store.state.system == 'android' &&
            applets != 'xcx' &&
            !$store.state.isXcx &&
            this.$store.state.isInGame
          "
          @click="closeCommunity"
        />
      </div>
      <div
        class="uploadPage_toptitle"
        style="background: #f5f5f5"
        v-if="$store.state.gameType == 5 && tabView"
      >
        <!-- <div
          v-if="$padFalg == 'other'"
          class="homePage_search"
          @click="toSearch"
        ></div> -->
        <div
          :class="`tab_intro ${currentTab == 1 ? ' tab_on' : ''}`"
          @click="changeTab(1)"
        >
          战略中心
        </div>
        <div
          :class="`tab_info ${currentTab == 2 ? ' tab_on' : ''}`"
          @click="changeTab(2)"
        >
          资料站
        </div>
        <!-- <div
          class="search_btn_box"
          v-if="$store.state.gameType != 2"
        >
          <div class="search_btn" @click="toSearch">
            <span></span>
            <p>搜索</p>
          </div>
        </div> -->
      </div>
      <div class="commonBg" v-if="$padFalg == 'other'"></div>
      <van-tabs
        v-model="active"
        @click="tabClick"
        v-if="
          $store.state.gameType != 2 &&
          $store.state.gameType != 3 &&
          $store.state.gameType != 4 &&
          $store.state.gameType != 5
        "
      >
        <van-tab
          v-for="(item, index) in tab1Arr"
          :key="item.tagId"
          :title="item.tagName"
          :id="item.tagId"
        >
          <listPage
            v-if="active == index"
            :class="item.tagName == '龙晶' ? '' : 'wide'"
            :tab2Arr="item.subTag"
            :listArr="listArr"
            @getList="getList"
          ></listPage>
        </van-tab>
      </van-tabs>
      <div
        class="gl-guidepage"
        v-if="$store.state.gameType == 2"
        :style="tabView && $padFalg != 'other' ? 'margin-top: 1.2rem' : ''"
      >
        <!-- <img src="../../assets/img/gl/guidepage-icon.png" alt="" style="margin: 0 auto;" /> -->
        <router-view @getTabView="getTabView"></router-view>
        <!-- <gameIntro @getTabView="getTabView" v-if="currentTab == 1" />
        <gameInfo @getTabView="getTabView" v-else /> -->
      </div>
      <div
        class="dqss-guidepage"
        v-if="$store.state.gameType == 3"
        :style="tabView && $padFalg != 'other' ? 'margin-top: 1.2rem' : ''"
      >
        <router-view @getTabView="getTabView"></router-view>
      </div>
      <div
        class="gl-guidepage"
        v-if="$store.state.gameType == 4"
        :style="tabView && $padFalg != 'other' ? 'margin-top: 1.2rem' : ''"
      >
        <router-view @getTabView="getTabView"></router-view>
      </div>
      <div
        class="gl-guidepage"
        v-if="$store.state.gameType == 5"
        :style="tabView && $padFalg != 'other' ? 'margin-top: 1.2rem' : ''"
      >
        <router-view @getTabView="getTabView"></router-view>
      </div>
      <!-- <div class="dqss_guidepage" v-if="$store.state.gameType == 3">
        <img src="../../assets/img/dqss/guidepage-icon.png" alt="" />
      </div> -->
    </div>
    <sideRight
      ref="sideRight"
      v-if="$padFalg != 'other' && $store.state.gameType !== 2"
    ></sideRight>
    <div
      class="side_right_box"
      v-if="$padFalg != 'other' && $store.state.gameType == 2"
    ></div>
  </div>
</template>

<script>
import listPage from './page/listPage.vue';
import gameIntro from './glPage/gameIntro/';
import gameInfo from './glPage/gameInfo/';
import get from '../../api/get';
import * as _code from '../../utils/code';
import sideRight from '@/components/sideRight';
import { Toast } from 'vant';
export default {
  name: 'guidePage',
  components: { listPage, sideRight, gameIntro, gameInfo },
  data() {
    return {
      tabView: true,
      currentTab: 1, //1攻略 2百科
      active: '',
      tab1Arr: [],
      listArr: [],
      applets: window.user.weixcode ? 'xcx' : ''
    };
  },
  watch: {
    currentTab: function () {
      //切换攻略百科操作
    },
    '$route.name': function () {
      if (
        (this.$store.state.gameType == 2 || this.$store.state.gameType == 4) &&
        this.$route.name == 'guidePage'
      ) {
        //已在战备页面，二次点击路由按钮，不会触发beforeRouteEnter
        this.$router.push({ path: '/guidePage/gameintro' });
        this.tabView = true;
        this.currentTab = 1;
      } else if (
        this.$store.state.gameType == 3 &&
        this.$route.name == 'guidePage'
      ) {
        this.$router.push({ path: '/guidePage/dqssgameintro' });
        this.tabView = true;
        this.currentTab = 1;
      } else if (this.$route.name == 'gameInfoMainPage') {
        this.currentTab = 2;
      } else if (this.$route.name == 'dqssgameintro') {
        this.currentTab = 1;
      }
      if (
        this.$route.path.indexOf('gameintro') ||
        this.$route.path.indexOf('gameInfoMainPage')
      ) {
        this.tabView = true;
      }
    }
  },
  beforeRouteEnter: (to, from, next) => {
    next((vm) => {
      if (
        (vm.$store.state.gameType == 2 && to.path == '/guidePage') ||
        (vm.$store.state.gameType == 4 && to.path == '/guidePage') ||
        (vm.$store.state.gameType == 5 && to.path == '/guidePage')
      ) {
        vm.$router.push({ path: '/guidePage/gameintro' });
      } else if (vm.$store.state.gameType == 3 && to.path == '/guidePage') {
        vm.$router.push({ path: '/guidePage/dqssgameintro' });
      } else {
        return true;
      }
    });
  },
  created() {
    if (
      this.$route.name == 'gameInfoMainPage' ||
      this.$route.name == 'dqssgameInfoMainPage'
    ) {
      this.currentTab = 2;
    }
    this.$eventBus.$on('guidePageInit', () => {
      //路由直接访问时被indexInfo触发加载
      this.init();
    });
    if (this.$store.state.token) {
      //路由跳转时初始化加载
      this.init();
    }
  },
  mounted() {},
  activated: function () {
    if (this.$padFalg != 'other' && this.$store.state.gameType != 2)
      this.$refs.sideRight.init();
  },
  methods: {
    toSearch() {
      if (this.$store.state.loginStatus == 1) {
        this.$router.push({ name: 'search', query: {} });
      } else {
        this.$store.commit('changeLoginShow', true);
      }
    },
    dqssChangeTab(val) {
      this.currentTab = val;
      if (val == 1) {
        this.$router.push({ path: './dqssgameintro' });
      } else {
        this.$router.push({ path: './dqssgameinfo' });
      }
    },
    changeTab(val) {
      this.currentTab = val;
      if (val == 1) {
        this.$router.push({ path: './gameintro' });
      } else {
        this.$router.push({ path: './gameinfo' });
      }
    },
    getTabView(val) {
      this.tabView = val;
    },
    init() {
      if (
        this.$store.state.gameType != 2 &&
        this.$store.state.gameType != 4 &&
        this.$store.state.gameType != 5
      ) {
        get.taglist().then((res) => {
          let data = res.data;
          if (data.code == 0) {
            this.tab1Arr = data.data;
            let id =
              this.tab1Arr[0].subTag.length != 0
                ? this.tab1Arr[0].subTag[0].id
                : this.tab1Arr[0].tagId;
            this.getList(id);
            $('body,html').animate({ scrollTop: 0 }, 0);
          } else {
            this.errorMessage(data);
          }
        });
      }
    },
    //一级tab点击事件
    tabClick(index, title) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      let id =
        JSON.stringify(this.tab1Arr[index].subTag) != '[]'
          ? this.tab1Arr[index].subTag[0].id
          : this.tab1Arr[index].tagId;
      this.getList(id);
    },
    //获取列表详情
    getList(id) {
      let form = {
        tagId: id
      };
      get.baikeList(form).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.listArr = data.data;
        } else {
          this.errorMessage(data);
        }
      });
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    },
    closeCommunity() {
      window.pd.onBBSClose();
    }
  }
};
</script>

<style lang="scss" scoped>
.guidePageWrap {
  .close_icon {
    width: 0.5rem;
    height: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0.2rem;
    right: 0.2rem;
    z-index: 5;
  }
}
.side_right_box {
  width: 3.5rem;
  margin-left: 0.4rem;
}
.search_btn_box {
  width: 4rem;
  height: 1.2rem;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0;
  right: -3.9rem;
  .search_btn {
    width: 3.1rem;
    height: 0.45rem;
    background: #fff;
    border-radius: 0.35rem;
    -webkit-border-radius: 0.35rem;
    -moz-border-radius: 0.35rem;
    -ms-border-radius: 0.35rem;
    -o-border-radius: 0.35rem;
    position: relative;
    font-size: 0.2rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 0.2rem;
    box-sizing: border-box;
    cursor: pointer;
    position: absolute;
    bottom: 0.2rem;
    p {
      line-height: 0.45rem;
      color: #808492;
      margin-left: 0.1rem;
    }
    span {
      display: inline-block;
      width: 0.2rem;
      height: 0.2rem;
      background: url(data:image/png;base64,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)
        no-repeat center;
      background-size: 100% auto;
    }
  }
}
</style>
